<template>
  <BlBackdrop
    title="Add therapists"
    :label="`Add ${input.length} therapist(s)`"
    :disabled="!input.length && false"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSubmit"
  >
    <div class="flex flex-col gap-4" :style="{ width: '40rem' }">
      <div class="px-8">
        <BlInputSearch :input="searchInput" @changed="onInputSearch" />
      </div>

      <div v-if="fetchLoading" class="h-64 grid place-items-center">
        <div class="blum-loader-sm"></div>
      </div>
      <div
        v-else-if="!userOptions.length"
        class="h-64 flex flex-col items-center justify-center"
      >
        <BlTextBody1 class="text-center" text="Team member(s) not found." />
      </div>
      <div
        v-else
        class="px-8 flex flex-col overflow-y-auto"
        :style="{ maxHeight: 'calc(100vh - 20rem)' }"
      >
        <div
          v-for="user in userOptions"
          :key="user.id"
          class="py-2 flex items-center gap-3 border-b border-slate-400 cursor-pointer"
          :class="{ 'pointer-events-none': isDisabled(user.id) }"
          @click="onChange(user)"
        >
          <BlInputCheck
            :checked="isChecked(user.id)"
            :disabled="isDisabled(user.id)"
            @changed="onChange(user)"
          />
          <div class="flex flex-col gap-1 truncate">
            <BlTextBody2 :text="user.name" class="text-slate-1000 truncate" />
            <BlTextBody2 :text="user.email" class="text-slate-700 truncate" />
          </div>
        </div>
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash/debounce";

import BlBackdrop from "../BlBackdrop.vue";
import BlTextBody1 from "../BlTextBody1.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlInputSearch from "../BlInputSearch.vue";
import BlInputCheck from "../BlInputCheck.vue";

export default {
  name: "UsersMultiSelect",
  components: {
    BlBackdrop,
    BlTextBody1,
    BlTextBody2,
    BlInputSearch,
    BlInputCheck
  },
  props: {
    list: { type: Array, default: () => [] }, // { id, name?, email? }[]
    disabledList: { type: Array, default: () => [] } // { id, name?, email? }[]
  },
  data() {
    return {
      fetchLoading: false,
      input: [...this.list],
      searchInput: { placeholder: "Search by name", model: "" },
      userOptions: [],
      totalUsers: []
    };
  },
  computed: {
    ...mapGetters(["currentCenter"])
  },
  watch: {},
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions(["actionGet"]),
    onInputSearch(payload) {
      payload.input.model = payload.value;
      this.onSearching();
    },
    onSearching: debounce(function() {
      this.fetch();
    }, 1000),
    //
    isChecked(id) {
      const ids = this.input.map(i => i.id);
      return ids.includes(id);
    },
    isDisabled(id) {
      const ids = this.disabledList.map(i => i.id);
      return ids.includes(id);
    },
    onChange(user) {
      if (this.isDisabled(user.id)) return;

      const ids = this.input.map(i => i.id);
      if (ids.includes(user.id)) {
        this.input = this.input.filter(i => i.id !== user.id);
      } else {
        this.input.push(user);
      }
    },
    //
    async fetch() {
      const params = {
        url: `/api/v1/users?per_page=50&sort=name_asc&status=active`
      };

      if (this.searchInput.model) {
        params.url += `&query=${this.searchInput.model}`;
      }

      this.userOptions = [];
      this.totalUsers = 0;

      this.fetchLoading = true;
      const { success, data } = await this.actionGet(params);
      this.fetchLoading = false;
      if (!success) return;

      this.userOptions = data.users;
      this.totalUsers = data.total_users;
    },
    onSubmit() {
      this.$emit("change", this.input);
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/UsersMultiSelect.vue